import { Suspense } from 'react';

import Description from '@picsart/growth-rc/Description';
import Title from '@picsart/growth-rc/Title';
import { useSearchParams } from 'react-router-dom';
import TopBannerSkeleton from './TopBannerSkeleton/TopBannerSceleton';

import useDynamicTitleAndDescription from '../hooks/useTitleAndDescription';

import { TopBannerType } from '../types';
import useStyles from './styles';

const TopBanner = ({ title, description, isLoading }: TopBannerType) => {
  const styles = useStyles();
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get('q');
  const { outputTitle, outputDescription } = useDynamicTitleAndDescription(title, description);

  if (isLoading) {
    return <TopBannerSkeleton />;
  }
  return (
    <Suspense fallback={null}>
      {searchValue && searchValue.length > 1 ? (
        <div className={styles.title}>&quot;{searchValue}&quot; fonts</div>
      ) : (
        <>
          <div className={styles.title}>{title && <Title {...outputTitle} />}</div>
          {description && (
            <div className={styles.description}>
              <Description {...outputDescription} />
            </div>
          )}
        </>
      )}
    </Suspense>
  );
};
export default TopBanner;
